module.exports = __webpack_public_path__ + "assets/media/chat-lol.c52f57df.mp3";